import { Component } from "@angular/core";
import { LocalStorageService } from "../../services/local-storage.service";
import { Router, NavigationEnd } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { RouterService } from "../../services/router.service";
import { Location, CommonModule } from "@angular/common";
import { LucideAngularModule } from "lucide-angular";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [MatIconModule, CommonModule, LucideAngularModule],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.css",
})
export class HeaderComponent {
  currentPage: string = "";
  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private routerService: RouterService,
    private location: Location,
  ) {
    this.setName();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setName();
      });
  }

  async setName() {
    const url = this.router.url.startsWith("/")
      ? this.router.url.substring(1)
      : this.router.url;

    const cleanUrl = url.split("?")[0].split("#")[0];
    this.currentPage = cleanUrl === "" ? "home" : cleanUrl;
    await this.localStorageService.setItem("currentPage", this.currentPage);

    const pageNames: { [key: string]: string } = {
      home: "ReBall",
      notification: "Notifications",
      "rb-rank": "RB Rank",
      "match-history": "Match History",
      friendships: "Friendships",
      "club-membership": "Club Membership",
      "book-a-court": "Book a Court",
      "invite-players": "Invite Players",
      "confirm-match": "Confirm Match",
      "search-players": "Search Players",
      "available-players": "Available Players",
      "edit-profile": "Edit Profile",
      "your-match": "Your Match",
      "employee-interface": "Employee Interface",
      "court-bookings": "Court Bookings",
      "manual-book": "Manual Booking",
      "fixed-booking": "Fixed Booking",
      "match-confirmations": "Match Confirmations",
      "system-alerts": "System Alerts",
      "my-club": "My Club",
      promotions: "Promotions",
      "approve-matches": "Approve Matches",
      "new-registrations": "New Registrations",
      analytics: "Analytics",
      unimplemented: "Coming Soon",
    };

    const pageDescriptions: { [key: string]: string } = {
      home: "Your padel journey starts here",
      notification: "Stay updated with your matches",
      "padel-point-rank": "Track your competitive progress",
      "match-history": "Review your past performances",
      friendships: "Connect with fellow players",
      "club-membership":
        "Join premium padel clubs and enjoy exclusive benefits",
      "book-a-court": "Reserve your perfect padel court experience",
      "invite-players": "Find players for your next match",
      "confirm-match": "Finalize your match details",
      "search-players": "Discover new playing partners",
      "available-players": "See who's ready to play",
      "edit-profile": "Update your personal information",
      "your-match": "Live match in progress",
      "employee-interface": "Club management dashboard",
      "court-bookings": "Manage court reservations",
      "manual-book": "Create phone reservations",
      "fixed-booking": "Set up recurring bookings",
      "match-confirmations": "Approve pending matches",
      "system-alerts": "Monitor club notifications",
      "my-club": "Your club information",
      promotions: "Special offers and deals",
      "approve-matches": "Review match requests",
      "new-registrations": "Manage new member signups",
      analytics: "Club performance insights",
      unimplemented: "Feature coming soon",
    };

    const basePage = this.currentPage.split("/")[0];

    if (
      this.currentPage.includes("profile/") &&
      !this.currentPage.includes("edit")
    ) {
      this.name = "Profile";
      this.description = "Your personal information";
      this.haveBackButton = true;
    } else if (this.currentPage.includes("confirmation/")) {
      this.name = "Confirmation";
      this.description = "Match booking confirmation";
      this.haveBackButton = true;
    } else if (pageNames[basePage]) {
      this.name = pageNames[basePage];
      this.description = pageDescriptions[basePage] || "";
      this.haveBackButton = basePage !== "home";
    } else {
      const formattedName = basePage
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      this.name = formattedName || "ReBall";
      this.description = pageDescriptions[basePage] || "";
      this.haveBackButton = basePage !== "home" && basePage !== "";
    }

    if (
      this.location.path().includes("employee-interface") &&
      !["court-bookings", "match-confirmations", "system-alerts"].includes(
        basePage,
      )
    ) {
      this.name = "Employee Interface";
      this.description = "Club management dashboard";
      this.haveBackButton = false;
      await this.localStorageService.setItem("previousPages", ["home"]);
      this.currentPage = "employee-interface";
      await this.localStorageService.setItem("currentPage", this.currentPage);
    }
  }

  back() {
    this.routerService.back();
  }
  name: string = "Padel Point";
  description: string = "";
  haveBackButton: boolean = false;

  goToUnimplemented() {
    this.routerService.navigateTo("unimplemented");
  }

  goToEditProfile() {
    this.routerService.navigateTo("edit-profile");
  }
}
